import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-careers-page',
  templateUrl: './careers-page.component.html',
  styleUrls: ['./careers-page.component.css']
})
export class CareersPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	$('#initialise-page').trigger('click');
  }

}
